import { render, staticRenderFns } from "./FamilyInfo1.vue?vue&type=template&id=a6bf86a0&scoped=true&"
import script from "./FamilyInfo1.vue?vue&type=script&lang=js&"
export * from "./FamilyInfo1.vue?vue&type=script&lang=js&"
import style0 from "./FamilyInfo1.vue?vue&type=style&index=0&id=a6bf86a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf86a0",
  null
  
)

export default component.exports